import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5dee4b94"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "lg:text-7xl text-4xl font-black text-center lg:mt-24 my-12 text-[#163537] dark:text-gray-200" }, " Tech Stack / Skills ")
], -1))
const _hoisted_2 = { class: "py-8 px-2 max-w-[95vw] sm:max-w-[754px] xl:max-w-[1240px] w-full mx-auto" }
const _hoisted_3 = { class: "grid grid-cols-3 sm:grid-cols-5 md:grid-cols-4 lg:grid-cols-6 md:gap-12 gap-6" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "md:text-lg text-sm font-semibold text-gray-900 dark:text-gray-200" }


export default /*#__PURE__*/_defineComponent({
  __name: 'TechStack',
  setup(__props) {

const techStack = [
  {
    name: "Vue.js",
    logo: "https://cdn.iconscout.com/icon/free/png-512/free-vue-282497.png",
  },
  {
    name: "ReactJs",
    logo: "https://cdn.iconscout.com/icon/free/png-512/free-react-3-1175109.png",
  },
  {
    name: "NextJs",
    logo: "https://www.svgrepo.com/show/354113/nextjs-icon.svg",
  },
  {
    name: "JavaScript",
    logo: "https://cdn.iconscout.com/icon/free/png-512/free-javascript-1-225993.png",
  },
  {
    name: "TypeScript",
    logo: "https://cdn.iconscout.com/icon/free/png-512/free-typescript-3521774-2945272.png",
  },
  {
    name: "Node.js",
    logo: "https://cdn.iconscout.com/icon/free/png-512/free-nodejs-2-226035.png",
  },
  {
    name: "Git",
    logo: "https://cdn.iconscout.com/icon/free/png-512/free-git-17-1175218.png",
  },
  {
    name: "GitHub",
    logo: "https://cdn.iconscout.com/icon/free/png-512/free-github-163-761603.png",
  },
  {
    name: "Redux",
    logo: "https://cdn.iconscout.com/icon/free/png-512/free-redux-3772327-3151453.png",
  },
  {
    name: "Postman",
    logo: "https://cdn.iconscout.com/icon/free/png-512/free-postman-3521648-2945092.png",
  },
  {
    name: "Figma",
    logo: "https://cdn.iconscout.com/icon/free/png-512/free-figma-3521426-2944870.png",
  },
  {
    name: "Notion",
    logo: "https://cdn.iconscout.com/icon/free/png-512/free-notion-10516019-8630396.png",
  },
  {
    name: "Trello",
    logo: "https://cdn.iconscout.com/icon/free/png-512/free-trello-226534.png",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(techStack, (tech) => {
          return _createElementVNode("div", {
            key: tech.name,
            id: "stack",
            class: "flex flex-col items-center gap-3 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-slate-300 dark:shadow-gray-900 shadow-lg border dark:border-gray-700"
          }, [
            _createElementVNode("img", {
              src: tech.logo,
              alt: tech.name,
              class: "size-12"
            }, null, 8, _hoisted_4),
            _createElementVNode("h3", _hoisted_5, _toDisplayString(tech.name), 1)
          ])
        }), 64))
      ])
    ])
  ], 64))
}
}

})